module.exports = {
          srcSet: __webpack_public_path__ + "c804a5e1d3108dcb246bc13ef114c5f8-161.png"+" 161w",
          images:[ {path: __webpack_public_path__ + "c804a5e1d3108dcb246bc13ef114c5f8-161.png",width: 161,height: 201}],
          src: __webpack_public_path__ + "c804a5e1d3108dcb246bc13ef114c5f8-161.png",
          toString:function(){return __webpack_public_path__ + "c804a5e1d3108dcb246bc13ef114c5f8-161.png"},
          
          width: 161,
          height: 201
        }